import React from 'react';

import { yup } from 'data';
import { profileService } from 'services';
import { useForm, useLang, useMutation } from 'hooks';
import { CardView } from 'components/layout';
import { Button, Flex, Form, Input } from 'components/ui';

type FormValues = {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
};

const initialValues: FormValues = {
  currentPassword: '',
  password: '',
  passwordConfirmation: '',
};

const validationSchema = yup.object({
  currentPassword: yup.string().required(),
  password: yup.string().required().password(),
  passwordConfirmation: yup.string().required().confirmation(yup.ref('password')),
});

const ProfilePasswordChange = () => {
  const form = useForm<FormValues>();
  const lang = useLang();

  const updatePasswordMutation = useMutation({
    mutationFn: (values: FormValues) => profileService.updatePassword(values.currentPassword, values.password),
    successNotification: lang.get('profile.passwordChange.success'),
  });

  return (
    <CardView
      title={lang.get('profile.passwordChange.title')}
      caption={lang.get('profile.passwordChange.caption')}
    >
      <Form
        form={form}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onFinish={updatePasswordMutation.mutateAsync}
      >
        <Form.Item name="currentPassword" label={lang.get('profile.passwordChange.currentPassword.label')}>
          <Input type="password" placeholder={lang.get('profile.passwordChange.currentPassword.placeholder')} />
        </Form.Item>
        <Form.Item name="password" label={lang.get('profile.passwordChange.password.label')}>
          <Input type="password" placeholder={lang.get('profile.passwordChange.password.placeholder')} />
        </Form.Item>
        <Form.Item name="passwordConfirmation" label={lang.get('profile.passwordChange.passwordConfirmation.label')}>
          <Input type="password" placeholder={lang.get('profile.passwordChange.passwordConfirmation.placeholder')} />
        </Form.Item>
        <Flex justify="flex-end">
          <Button htmlType="submit" loading={updatePasswordMutation.isPending}>
            {lang.get('common.actions.save')}
          </Button>
        </Flex>
      </Form>
    </CardView>
  );
};

export default ProfilePasswordChange;
